import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import TamaraReturnBase from "./TamaraReturnBase";
import { Api } from "../../api";

const TamaraFail = (props) => {
  const searchParams = new URLSearchParams(props.location.search);
  const paymentId = searchParams.get("payment_id");

  useEffect(() => {
    if (paymentId) {
      Api.cart.retrieveTabbyPayment(paymentId)
        .then((res) => {
          console.log("Retrieved Tabby payment (failure page):", res);
          // You could customize the UI based on status or reason if needed
        })
        .catch((err) => {
          console.error("Error retrieving Tabby payment on failure page", err);
        });
    }
  }, [paymentId]);
  return (
    <TamaraReturnBase
      iconClass="fa-times-circle text-danger"
      title="فشلت عملية الدفع"
      message="نأسف، تابي غير قادرة على الموافقة على هذه العملية. الرجاء استخدام طريقة دفع أخرى."
      buttonText="العودة إلى الدفع"
      buttonAction={() => props.history.push("/cart")}
    />
  );
};

export default withRouter(TamaraFail);
